import { createSelector } from 'reselect';

/**
 * Direct selector to the assessment state domain
 */

const selectAdminAssessmentResultTestDomain = state =>
  state.adminAssessmentResultTest;

/**
 * Other specific selectors
 */

/**
 * Default selector used by Assessment
 */

const makeSelectProcessing = () =>
  createSelector(
    selectAdminAssessmentResultTestDomain,
    substate => substate.processing,
  );
const makeSelectAssessmentsData = () =>
  createSelector(
    selectAdminAssessmentResultTestDomain,
    substate => substate.data,
  );
const makeSelectStoredData = () =>
  createSelector(
    selectAdminAssessmentResultTestDomain,
    substate => substate.storedData,
  );

export {
  makeSelectProcessing,
  makeSelectAssessmentsData,
  makeSelectStoredData,
};
